import { Draft, PayloadAction } from '@reduxjs/toolkit';
import formatters from 'formatters';
import { IInterventionNote } from 'models/InterventionDetails';

import IAddNoteInterventionResponse from 'services/httpClient/responses/intervention/IAddNoteInterventionResponse';

import { IInterventionData } from '../../initialState';

interface IAddNoteInterventionSuccessAction {
  note: IAddNoteInterventionResponse;
}

function addNoteSuccess(
  draft: Draft<IInterventionData>,
  action: PayloadAction<IAddNoteInterventionSuccessAction>,
) {
  draft.addNote.config.isLoading = false;

  const noteFormatted: IInterventionNote = {
    createdAt: formatters.date(action.payload.note.created_at, {
      formatType: 'DD/MM/YYYY',
    }),
    id: action.payload.note.id,
    text: action.payload.note.text,
    wroteBy: action.payload.note.wrote_by,
  };

  if (draft.getDetails.values) {
    draft.getDetails.values.notes.unshift(noteFormatted);
  }
}

export default addNoteSuccess;
